import { Box, Typography } from "@mui/material";
import { T_DigiHoldingsTransactionObject } from "../../features/Feature_ABCD/Feature_ABCD_Types";
import { nanoid } from "@reduxjs/toolkit";
import { FC } from "react";
import {
  currencyConvertor,
  getRecentTransactionsIcon,
  getRecentTransactionsText,
  getRecentTransactionsTextColor,
} from "../../utils/conversionUtils";
import "./CustomDigiItemRecentTransactions.scss";
import { Colors } from "../../styles/constant";
import dayjs from "dayjs";

interface Props {
  transaction: T_DigiHoldingsTransactionObject;
}
export const CustomDigiItemRecentTransactions: FC<Props> = ({
  transaction,
}) => {
  return (
    <>
      <Box
        key={nanoid()}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        padding="0.5rem"
      >
        <Box display="flex" flexDirection="row" gap="0.5rem">
          <img
            src={getRecentTransactionsIcon(
              transaction.status,
              transaction.type
            )}
            alt="Gift icon"
          />
          <Box display="flex" flexDirection="column" columnGap="0.25rem">
            <Typography
              fontWeight="500"
              fontSize=".875rem"
              lineHeight=".9625rem"
              color="#2F343A"
            >
              {transaction.header}
            </Typography>
            <Typography>
              <span
                style={{
                  textTransform: "capitalize",
                  fontWeight: "400",
                  fontSize: ".75rem",
                  lineHeight: ".825rem",
                  color: getRecentTransactionsTextColor(transaction.status),
                  marginRight: ".25rem",
                }}
              >
                {getRecentTransactionsText(transaction.status)}
              </span>
              <span
                style={{
                  fontWeight: "600",
                  fontSize: ".75rem",
                  lineHeight: "1.125rem",
                  color: Colors.quartz,
                  marginRight: ".25rem",
                }}
              >
                .
              </span>
              <span
                style={{
                  fontWeight: "400",
                  fontSize: ".875rem",
                  lineHeight: ".9625rem",
                  color: Colors.quartz,
                }}
              >
                {dayjs(transaction.createdAt).format("DD-MMM-YY")}
              </span>
            </Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          gap="0.5rem"
          alignItems="center"
        >
          <Box display="flex" flexDirection="column" columnGap="0.25rem">
            <Typography variant="h5" lineHeight=".9625rem" textAlign="right">
              {transaction.amount
                ? transaction.amount === "0.0"
                  ? "₹0.0"
                  : `${currencyConvertor(
                      parseFloat(transaction.amount).toFixed(2)
                    )}`
                : "----"}
            </Typography>
            <Typography
              variant="subtitle2"
              lineHeight=".9625rem"
              color={Colors.quartz}
            >
              {`${transaction.quantity}gm`}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};
